import React from 'react';
import { connect } from 'react-redux';
import intl from '../shared/intl';
import Error from '../../modules/shared/errors/404';

const NotFound = props => <Error {...props} />;

export default connect(
	state => ({
		intl: intl(state)
	})
)(NotFound);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/not-found/main.js